import React from 'react';

function Section({ title, children }) {
  return (
    <section className="mb-6">
      <h2 className="text-lg font-semibold text-white mb-2">{title}</h2>
      <div className="text-sm text-slate-300 leading-6">{children}</div>
    </section>
  );
}

export default function LegalDocumentScreen({ type = 'privacy' }) {
  const isPrivacy = type === 'privacy';
  const title = isPrivacy ? 'Política de Privacidade' : 'Termos de Uso';
  const updatedAt = '01/06/2026';

  return (
    <div className="min-h-screen bg-[#0b1020] text-slate-100 px-4 py-10">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white">{title}</h1>
          <p className="text-sm text-slate-400 mt-2">Photofine Pro • Atualizado em {updatedAt}</p>
        </div>

        {isPrivacy ? (
          <>
            <Section title="1. Quem Somos">
              A Photofine opera o sistema Gestao Photofine para controle de tarefas e operacoes internas do estudio.
            </Section>
            <Section title="2. Dados Coletados">
              Coletamos dados de autenticação (nome, email, perfil), dados operacionais de tarefas e logs de auditoria das ações no sistema.
            </Section>
            <Section title="3. Integrações Google">
              Quando você conecta sua conta Google, o sistema utiliza OAuth para acessar apenas os escopos autorizados (Drive, Docs e Agenda).
              Tokens de refresh são armazenados de forma criptografada para executar comandos em nome do usuário autenticado.
            </Section>
            <Section title="4. Finalidade do Uso">
              Os dados são usados para operação do sistema, colaboração entre equipe, automação via Foto AI e segurança/auditoria.
            </Section>
            <Section title="5. Compartilhamento">
              Não vendemos dados pessoais. Dados podem ser processados por provedores de infraestrutura e APIs necessárias para funcionamento
              (ex.: Google e DeepSeek), conforme autorização do usuário e configuração do sistema.
            </Section>
            <Section title="6. Seguranca">
              Aplicamos controles de autenticação, autorização por perfil e trilhas de auditoria. Nenhuma medida é absoluta, mas adotamos boas
              praticas de protecao de dados.
            </Section>
            <Section title="7. Direitos do Usuário">
              O titular pode solicitar informações, correção ou remoção de dados conforme legislação aplicável, via contato oficial.
            </Section>
            <Section title="8. Contato">
              Para duvidas de privacidade, contate: contato@photofine.com.br
            </Section>
          </>
        ) : (
          <>
            <Section title="1. Aceitação">
              Ao usar o Gestão Photofine, você concorda com estes Termos de Uso e com a Política de Privacidade.
            </Section>
            <Section title="2. Acesso e Conta">
              O acesso é pessoal e vinculado ao usuário cadastrado. O usuário é responsável pela confidencialidade das credenciais.
            </Section>
            <Section title="3. Uso Permitido">
              O sistema deve ser usado para operações legítimas da empresa, sem tentativas de abuso, fraude, engenharia reversa indevida ou acesso não autorizado.
            </Section>
            <Section title="4. Foto AI e Automacoes">
              A Foto AI executa comandos com base no contexto do usuário autenticado. Ações sensíveis podem exigir confirmação explícita.
            </Section>
            <Section title="5. Integrações de Terceiros">
              Integrações como Google Workspace dependem da autorização OAuth do usuário e das políticas do provedor terceiro.
            </Section>
            <Section title="6. Disponibilidade">
              Buscamos alta disponibilidade, mas pode haver indisponibilidades temporarias por manutencao, rede ou terceiros.
            </Section>
            <Section title="7. Limitação de Responsabilidade">
              O usuário deve revisar dados críticos antes de decisões finais. A plataforma não garante ausência total de falhas.
            </Section>
            <Section title="8. Alteracoes">
              Estes termos podem ser atualizados periodicamente. A data de atualização no topo indica a versão vigente.
            </Section>
            <Section title="9. Contato">
              Duvidas juridicas/contratuais: contato@photofine.com.br
            </Section>
          </>
        )}
      </div>
    </div>
  );
}

